import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import type { RouteObject } from "react-router-dom";
import routes from "./routes";
import ConditionalRoute from "@/components/ConditionalRoute/ConditionalRoute";
import PreLogin from "@/layouts/PreLogin/PreLogin";
import DisRoutes from "./DisRoutes";
import DisPostLogin from "@/layouts/DisPostLogin/DisPostLogin";
import LandingPage from "@/pages/LandingPage/LandingPage";
import RoleLayout from "@/pages/Role/RoleLayout";
import DistributorRoutes from "./DistributorRoutes";
import RetailerRoutes from "./RetailerRoutes";
import RoleBasedPrivateRoutes from "./PrivateRouteWrapper";



export interface RouteConfig {
  path: string;
  element?: React.ReactNode; // make optional
  children?: Record<string, RouteConfig> | RouteConfig[];
  pageName?: string;
  sidebar?: { show: boolean };
  permissionName?: string;
}

const getPrivateRoutes = (role : any) => {
  switch (role) {
    case "distributor":
      return DistributorRoutes;
    case "retailer":
      return RetailerRoutes;
    default:
      return [];
  }
};

export const buildRoutes = (
  routesInput: Record<string, RouteConfig> | RouteConfig[]
): RouteObject[] => {
  const routesArray: RouteConfig[] = Array.isArray(routesInput)
    ? routesInput
    : Object.values(routesInput);

  return routesArray.map(({ path, element, children }) => ({
    path,
    ...(element ? { element } : {}), // only include element if it exists
    ...(children ? { children: buildRoutes(children) } : {}),
  }));
};



const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Navigate
        to={DisRoutes?.routes?.LANDING_PAGE?.path}
        replace
      />
    ),
  },

  // PreLogin layout
  {
    path: "/",
    element: <PreLogin />,
    children: [
      {
        index: true,
        element: <LandingPage />, 
      },
      {
        path: ":role",
        element: (
          <RoleLayout />
        ),
        children: [
          { path: "login", element: DisRoutes.publicRoutes?.DIS_LOGIN?.element },
          { path: "registration", element: DisRoutes.publicRoutes?.DIS_REGISTER?.element },
          { path: "forgot-password", element: DisRoutes.publicRoutes?.DIS_FORGOT_PASSWORD?.element },
          { path: "otp-verification", element: DisRoutes.publicRoutes?.DIS_OTP_VERIFICATION?.element },
          { path: "login-otp-verification", element: DisRoutes.publicRoutes?.DIS_LOGIN_OTP_VERIFICATION?.element },
        ],
      }
    ],
  },

  
  // Redirect root to login
  // {
  //   path: "/",
  //   element: (
  //     <Navigate
  //     to={DisRoutes?.publicRoutes ? DisRoutes.routes?. LANDING_PAGE?.path : "/"}
  //       // to={routes?.publicRoutes ? routes.publicRoutes?.LOGIN?.path : "/"}
  //       replace
  //     />
  //   ),
  // },

  // Open routes
  // ...buildRoutes(DisRoutes.routes),
  // // ...buildRoutes(routes.routes),
  // {
  //   path:"/",
  //   element: <PreLogin />, 
  //   children: [
  //     {
  //       index: true,
  //       element: (
  //         <Navigate
  //           to={DisRoutes?.routes?.LANDING_PAGE?.path ?? "*"}
  //         />
  //       ),
  //     },
  //     {
  //       path: ":role",
  //       children:[
  //         {
  //           path: "login",
  //           element: DisRoutes.publicRoutes?.DIS_LOGIN?.element
  //         },
  //         {
  //           path: "registration",
  //           element: DisRoutes.publicRoutes?.DIS_REGISTER?.element
  //         },
  //         {
  //           path: "forgot-password",
  //           element: DisRoutes.publicRoutes?.DIS_FORGOT_PASSWORD?.element
  //         },
  //         {
  //           path: "otp-verification",
  //           element: DisRoutes.publicRoutes?.DIS_OTP?.element
  //         },

  //       ]
  //     }
     
  //   ],
  // },
  // Public routes
  // {
  //   path: "/",
  //    element: <PreLogin />, 
  //   children: [
  //     {
  //       index: true,
  //       element: (
  //         <Navigate
  //           to={DisRoutes?.routes?. LANDING_PAGE?.path ?? "*"}
  //         />
  //       ),
  //     },
  //     ...buildRoutes(DisRoutes.publicRoutes),
      
  //   ],
  // },

  // Private routes
  {
    path: "/:role",
    element: <ConditionalRoute isPrivate component={DisPostLogin} />,
    children: [
      {
        path: "*",
        element: <RoleBasedPrivateRoutes />,
      },
    ],
  }
  // {
  //   path: "/",
  //   element: <ConditionalRoute isPrivate component={DisPostLogin} />,
   
  //   children: getPrivateRoutes(role)
  //   // children: [
  //   //   // ...buildRoutes(routes.privateRoutes),
  //   //   ...buildRoutes(DisRoutes.privateRoutes),
  //   //   {
  //   //     index: true,
  //   //     element: <Navigate to={DisRoutes.privateRoutes.Supplier?.path} />,
  //   //   },
  //   // ],
  // },

  // Catch-all
  // {
  //   path: "*",
  //   element: <PageNotFound />,
  // },
]);

export default router;
